export default class Feedback {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Feedback.prototype.defaults, ...options }
        this.init()
    }

    init() {
        document.addEventListener("feedback:show", this.onFeedback.bind(this))
    }

    onFeedback(e) {
        switch (e.detail.type) {
            case "panel":
                this.showPanelFeedback(e.detail.level, e.detail.panel)
                break
            case "loading":
                this.showLoadingAnimation()
                break
            case "main":
                if (!e.detail.is_panel) {
                    this.showMainNotification(e.detail.feedback)
                }
                if (e.detail.feedback.message || e.detail.feedback.title) {
                    this.showStatus(e.detail.feedback, e.detail.status)
                }
                break
            case "toast":
                this.showToast(e.detail.feedback)
                break
        }
    }

    showPanelFeedback(type = "success", panel) {
        switch (type) {
            case "success":
            default:
                panel.innerHTML = `
                    <div class="c-panel__feedback_success">
                        <svg xmlns="http://www.w3.org/2000/svg" class="svg-success" viewBox="0 0 24 24">
                            <g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                            <circle class="success-circle-outline" cx="12" cy="12" r="11.5"/>
                            <circle class="success-circle-fill" cx="12" cy="12" r="11.5"/>
                            <polyline class="success-tick" points="17,8.5 9.5,15.5 7,13"/>
                            </g>
                        </svg>
                    </div>`
                break
            case "error":
                panel.innerHTML = `
                    <div class="c-panel__content">
                        <header class="c-header">
                            <div></div>
                            <div class="c-header__right">
                                <button class="c-close js-close" type="button"></button>
                            </div>
                        </header>
                        <div class="c-panel__feedback_error">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-success u-m-l" viewBox="0 0 24 24">
                                <g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                                <circle class="error-circle-outline" cx="12" cy="12" r="11.5"/>
                                <circle class="error-circle-fill" cx="12" cy="12" r="11.5"/>
                                <polyline class="success-tick" points="7,7 21,21"></polyline>
                                <polyline class="success-tick" points="7,17 21,3"></polyline>
                                </g>
                            </svg>
                            <div class="message">Oops! something went wrong.</div>
                        </div>
                    </div>`
                break
            case "not-found":
                panel.innerHTML = `
                    <div class="c-panel__feedback_error">
                        <svg xmlns="http://www.w3.org/2000/svg" class="svg-success u-m-l" viewBox="0 0 24 24">
                            <g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                            <circle class="error-circle-outline" cx="12" cy="12" r="11.5"/>
                            <circle class="error-circle-fill" cx="12" cy="12" r="11.5"/>
                            <polyline class="success-tick" points="7,7 21,21"></polyline>
                            <polyline class="success-tick" points="7,17 21,3"></polyline>
                            </g>
                        </svg>
                        <h3 class="title">Page not found</h3>
                    </div>`
                break
        }
    }

    showStatus(feedback, status) {
        if (!status) {
            return
        }

        status.classList.remove("u-hide")
        let type = feedback.type ?? "success"
        // Create an x-status component
        let $status = document.createElement("div")
        $status.classList.add("c-status", "js-status", "c-status--" + type)
        $status.setAttribute("type", type)
        $status.setAttribute("data-autoclose", 10000)

        let $title = document.createElement("h4")
        $title.classList.add("c-status__heading")
        $title.innerHTML = feedback.title ?? ""
        $status.appendChild($title)

        let $body = document.createElement("p")
        $body.classList.add("c-status__text")
        $body.innerHTML = feedback.message ?? ""
        $status.appendChild($body)

        let $close = document.createElement("button")
        $close.classList.add("c-status__hide", "js-statusHide")
        $close.setAttribute("type", "button")
        $status.appendChild($close)

        status.appendChild($status)
    }

    removeMainNotification() {
        if (!this.DOM.notification) {
            return
        }

        this.DOM.notification.classList.add("xhrForm-notification--is-hiding")
        this.DOM.notification.classList.remove("xhrForm-notification--is-show")

        setTimeout(() => {
            this.DOM.notification.remove()

            delete this.DOM.notification
        }, 400)
    }

    showMainNotification(feedback) {
        // create the notification
        this.DOM.notification = document.createElement("div")
        this.DOM.notification.classList.add("xhrForm-notification")

        this.DOM.overlay = document.createElement("div")
        this.DOM.overlay.classList.add("xhrForm-notification__overlay")
        this.DOM.notification.appendChild(this.DOM.overlay)

        this.DOM.progress = document.createElement("div")
        this.DOM.progress.classList.add("xhrForm-notification__progress")
        this.DOM.overlay.appendChild(this.DOM.progress)

        this.DOM.notification.classList.add("xhrForm-notification--is-loading")

        document.body.appendChild(this.DOM.notification)

        this.DOM.notification.classList.add("xhrForm-notification--is-showing")

        setTimeout(() => {
            this.DOM.notification.classList.add("xhrForm-notification--is-show")

            setTimeout(() => {
                this.DOM.notification.classList.remove("xhrForm-notification--is-showing")
            }, 400)
        }, 15)

        // show it
        setTimeout(() => {
            let type = feedback.type ?? "info"
            let message
            switch (feedback.type) {
                case 'error':
                    message = "Something went wrong"
                    break
                case 'info':
                case 'success':
                default:
                    message = "✌️"
            }

            if (feedback.title) {
                message = feedback.title
            }

            this.DOM.notification.classList.add("xhrForm-notification--has-loaded")
            this.DOM.notification.classList.add("xhrForm-notification--is-" + type)

            this.DOM.message = document.createElement("div")
            this.DOM.message.classList.add("xhrForm-notification__message")
            this.DOM.message.innerText = message

            this.DOM.progress.appendChild(this.DOM.message)

            setTimeout(() => {
                this.DOM.notification.classList.remove("xhrForm-notification--is-loading")

                this.DOM.timeout = setTimeout(() => {
                    this.removeMainNotification()
                }, 2600)

                setTimeout(() => {
                    this.DOM.notification.addEventListener(
                        "click",
                        () => {
                            clearTimeout(this.DOM.timeout)

                            this.removeMainNotification()
                        },
                        {
                            once: true,
                        }
                    )
                }, 400)
            }, 400)
        }, 15)
    }

    showToast(feedback) {
        let notificationContent = {
            title: feedback.title ? feedback.title : "",
            message: feedback.message,
            type: feedback.type ? feedback.type : "success",
        }
        document.body.dispatchEvent(new CustomEvent("notification:show", { detail: notificationContent }))
    }
}

Feedback.prototype.defaults = {}
